// Bulk select / shift-range for org applicants on /org/:id/users (members_all pending list).

let orgPendingBulkLastIndex = null
let orgPendingBulkLastContainer = null

function clickTargetElement (e) {
  const t = e.target
  if (t && t.nodeType === Node.ELEMENT_NODE) return t
  return t && t.parentElement
}

function syncOrgPendingSelectAll(container) {
  const alertEl = container.closest('.alert')
  const toolbar = alertEl && alertEl.querySelector('.org-pending-bulk-toolbar')
  const master = toolbar && toolbar.querySelector('.org-pending-select-all')
  if (!master) return
  const boxes = [...container.querySelectorAll('.org-pending-select-cb')]
  const n = boxes.length
  const c = boxes.filter((b) => b.checked).length
  master.indeterminate = c > 0 && c < n
  master.checked = n > 0 && c === n
}

function updateOrgPendingBulkButtons(container) {
  const alertEl = container.closest('.alert')
  const toolbar = alertEl && alertEl.querySelector('.org-pending-bulk-toolbar')
  if (!toolbar) return
  const n = container.querySelectorAll('.org-pending-select-cb:checked').length
  toolbar.querySelectorAll('.org-pending-bulk-deny, .org-pending-bulk-spam').forEach((btn) => {
    btn.disabled = n === 0
  })
}

document.addEventListener('click', (e) => {
  const el = clickTargetElement(e)
  const cb = el && el.closest ? el.closest('.org-pending-select-cb') : null
  if (cb) {
    const container = cb.closest('.members-pending[data-org-id]')
    if (!container) return
    const boxes = [...container.querySelectorAll('.org-pending-select-cb')]
    const idx = boxes.indexOf(cb)
    if (idx < 0) return
    if (
      e.shiftKey &&
      orgPendingBulkLastContainer === container &&
      orgPendingBulkLastIndex != null
    ) {
      const lo = Math.min(orgPendingBulkLastIndex, idx)
      const hi = Math.max(orgPendingBulkLastIndex, idx)
      const on = cb.checked
      for (let i = lo; i <= hi; i += 1) {
        if (i !== idx) boxes[i].checked = on
      }
    }
    orgPendingBulkLastIndex = idx
    orgPendingBulkLastContainer = container
    syncOrgPendingSelectAll(container)
    updateOrgPendingBulkButtons(container)
    return
  }

  const actionBtn = el && el.closest ? el.closest('.org-pending-bulk-deny, .org-pending-bulk-spam') : null
  if (!actionBtn) return
  if (actionBtn.disabled) return
  e.preventDefault()
  const toolbar = actionBtn.closest('.org-pending-bulk-toolbar')
  const wrap = toolbar && toolbar.closest('.alert')
  const container = wrap && wrap.querySelector('.members-pending[data-org-id]')
  if (!container) return
  const ids = [...container.querySelectorAll('.org-pending-select-cb:checked')].map((c) =>
    parseInt(c.value, 10)
  )
  if (!ids.length) return
  const url = actionBtn.dataset.url
  const token = document.querySelector('meta[name="csrf-token"]')
  const csrf = token && token.content
  actionBtn.disabled = true
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrf
    },
    credentials: 'same-origin',
    body: JSON.stringify({ user_ids: ids })
  })
    .then((res) => res.json().then((data) => ({ res, data })))
    .then(({ res, data }) => {
      if (res.ok && data.success) {
        window.location.reload()
        return
      }
      window.alert(data.error || data.message || 'Request failed')
      actionBtn.disabled = false
      updateOrgPendingBulkButtons(container)
    })
    .catch(() => {
      window.alert('Network error')
      actionBtn.disabled = false
      updateOrgPendingBulkButtons(container)
    })
})

document.addEventListener('change', (e) => {
  if (!e.target.classList || !e.target.classList.contains('org-pending-select-all')) return
  const master = e.target
  const orgId = master.dataset.orgId
  const toolbar = master.closest('.org-pending-bulk-toolbar')
  const wrap = toolbar && toolbar.closest('.alert')
  const container =
    wrap &&
    wrap.querySelector(`.members-pending[data-org-id="${orgId}"]`)
  if (!container) return
  const on = master.checked
  container.querySelectorAll('.org-pending-select-cb').forEach((c) => {
    c.checked = on
  })
  orgPendingBulkLastIndex = null
  orgPendingBulkLastContainer = container
  syncOrgPendingSelectAll(container)
  updateOrgPendingBulkButtons(container)
})
